export function NotFoundPage() {
  return (
    <div className="text-muted-foreground">
      <p>Page not found.</p>
    </div>
  );
}
